import {
  Bot,
  Eye,
  LayoutDashboard,
  type LucideIcon,
  Rss,
  Search,
  Settings,
  Sparkles,
} from 'lucide-react'

export interface InvestorNavItem {
  icon: LucideIcon
  label: string
  to: string
}

/** Labels double as the `activeNav` value each page passes to the layout. */
export const INVESTOR_NAV_LABEL = {
  search: 'Search',
  following: 'Following',
  connectAi: 'Connect your AI',
  settings: 'Settings',
} as const

export const INVESTOR_NAV_ITEMS: InvestorNavItem[] = [
  { icon: Search, label: INVESTOR_NAV_LABEL.search, to: '/search' },
  { icon: Eye, label: INVESTOR_NAV_LABEL.following, to: '/follows' },
  { icon: Bot, label: INVESTOR_NAV_LABEL.connectAi, to: '/connect-ai' },
]

/** Pinned to the bottom of the sidebar, apart from the main pages. */
export const INVESTOR_NAV_SETTINGS: InvestorNavItem = {
  icon: Settings,
  label: INVESTOR_NAV_LABEL.settings,
  to: '/settings',
}

/** The sidebar of investors the AI assistant is not open for. */
export const INVESTOR_NAV_CLASSIC: InvestorNavItem[] = [
  { icon: LayoutDashboard, label: 'Dashboard', to: '/' },
  { icon: Sparkles, label: 'Deal Flow', to: '/deal-flow' },
  { icon: Rss, label: 'Feed', to: '/feed' },
  INVESTOR_NAV_SETTINGS,
]
